import { Card, CardBody, CardHeader } from '@hvac/ui';
import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <main className="flex min-h-dvh items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader title="Page not found" description="That address does not exist." />
        <CardBody>
          <Link
            to="/"
            className="inline-flex h-10 items-center justify-center rounded-[var(--radius-control)] bg-brand-600 px-4 text-sm font-medium text-white hover:bg-brand-700"
          >
            Back to overview
          </Link>
        </CardBody>
      </Card>
    </main>
  );
}
